import React from 'react'
import Container from './Container'

export { Container }

export default { Container }
